<template>
  <div>
    <DolphinTextarea
      v-model="value"
      :rows="rows"
      :autoGrow="autoGrow"
      :disabled="disabled"
      :invalid="invalid"
      :placeholder="placeholder"
    />
    <p :class="$style.counter">
      <IconPen :class="$style.counter__icon" />
      <span :class="$style.counter__text">{{ letterCount }}文字</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import DolphinTextarea from '@/components/atoms/DolphinTextarea.vue'
import IconPen from '@/components/icons/IconPen.vue'

export default defineComponent({
  name: 'CountingTextarea',
  components: {
    DolphinTextarea,
    IconPen,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 2,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const value = computed({
      get: () => props.modelValue,
      set: (value: string) => emit('update:modelValue', value),
    })
    const letterCount = computed(
      () => props.modelValue.replace(/\r?\n/g, '').length
    )

    return {
      value,
      letterCount,
    }
  },
})
</script>

<style lang="scss" module>
.counter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 8px;
  padding-right: 4px;
  color: $color-text-and-object-low-emphasis;
  font-size: 10px;
  text-align: right;

  &__icon {
    padding-right: 4px;
    color: $color-text-and-object-low-emphasis;
  }

  &__text {
    color: $color-text-and-object-low-emphasis;
    font-size: 10px;
  }
}
</style>
